import React, {PureComponent} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import Link, {ButtonRouterLink} from "@irati/ui/src/Link"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import Icon from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import {Body, H3} from "@irati/ui/src/Typography"

const PerksGOImage = styled(Icon)`
  margin: ${({theme}) => `${theme.spacing.two} 0 ${theme.spacing.three}`};
  width: 80px;
  height: 52px;
`
class NoCardsBlock extends PureComponent {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    showModal: PropTypes.func.isRequired
  }

  render() {
    const {formatMessage, showModal} = this.props

    return (
      <Flex direction="column" alignItems="center">
        <H3 marginBottom={1}>
          <FormattedMessage id="perksgo.perksGoImportantInfo.title" />
        </H3>
        <Body small textAlign="center">
          <FormattedMessage id="perksgo.perksGoImportantInfo.noCardsBlock.title" />
        </Body>
        <PerksGOImage icon="perksGO" size={80} />
        <ButtonRouterLink
          marginBottom={2}
          primary
          full
          onClick={showModal}>
          <FormattedMessage id="perksgo.perksGoImportantInfo.noCardsBlock.button" />
        </ButtonRouterLink>
        <Link
          href={formatMessage({id: "perksgo.perksGoImportantInfo.noCardsBlock.help.href"})}
          target="_blank">
          <FormattedMessage id="perksgo.perksGoImportantInfo.noCardsBlock.help.text" />
        </Link>
      </Flex>
    )
  }
}

export default injectIntl(NoCardsBlock)
